.wrapper {
    display: flex;
    align-items: flex-start;
    gap: var(--tempest-masonry-gap, var(--tempest-space-4));
    width: 100%;
}

.column {
    display: flex;
    flex: 1 1 0;
    flex-direction: column;
    gap: var(--tempest-masonry-gap, var(--tempest-space-4));
    min-width: 0;
}

.item {
    min-width: 0;
}
